<template>
  <!-- Controls container -->
  <div class="map-buttons-container justify-content-center" :style="containerStyle">
    <!-- Location -->
    <button class="map-btn" aria-label="My location" @click="locationButton">
      <span class="material-icons" id="location_icon">my_location</span>
    </button>

    <!-- Zoom out -->
    <button class="map-btn" aria-label="Zoom out" @click="zoomOut">
      <span class="material-icons">remove</span>
    </button>

    <!-- Zoom in -->
    <button class="map-btn" aria-label="Zoom in" @click="zoomIn">
      <span class="material-icons">add</span>
    </button>

    <!-- Orientation reset -->
    <button class="map-btn" aria-label="Reset bearing/pitch" @click="orientationButton">
      <svg width="10" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0L11.1962 9H0.803848L6 0Z" fill="white"/>
        <path opacity="0.4" d="M6 23L0.803849 14L11.1962 14L6 23Z" fill="white"/>
      </svg>
    </button>

    <!-- Fit bounds -->
    <button class="map-btn" aria-label="Fit map to bounds" @click="boundsButton">
      <span class="material-icons">crop_free</span>
    </button>

    <!-- 3D Toggle -->
    <button class="map-btn" aria-label="Toggle 3D mode" @click="toggle3D" :class="{ active: is3DEnabled }">
      <span><strong>3D</strong></span>
    </button>
  </div>
</template>

<script>
import { RevenueCatWrapper } from '../../utils/RevenueCatWrapper';
import emitter from '../../utils/bus';
import { ThreeDimensionalMapManager } from '../../utils/models/MapStyles';
export default {
  name: 'MapControlsHorizontal',
  props: {
    /** [[minLng, minLat], [maxLng, maxLat]] */
    fitBounds: {
      type: Array,
      default: () => [[-180, -85], [180, 85]],
    },
    fitBoundsPadding: {
      type: Number,
      default: 40,
    },
    /** Optional margin from top in pixels. Default is 12px from CSS */
    marginTop: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      is3DEnabled: ThreeDimensionalMapManager.is3DModeEnabled()
    };
  },
  computed: {
    containerStyle() {
      if (this.marginTop !== null) {
        // Handle both number (assumed px) and string values (e.g., '20px', '2rem')
        const topValue = typeof this.marginTop === 'number'
          ? `${this.marginTop}px`
          : this.marginTop;
        return { top: topValue };
      }
      return {};
    },
  },
  mounted() {
    /* Stop the spin animation as soon as geolocation resolves */
    window.geolocateLocated = () =>
      document.getElementById('location_icon').classList.remove('spin');
    window.geolocateError = () =>
      document.getElementById('location_icon').classList.remove('spin');

    emitter.on('map:3d-state-changed', this.handle3DStateChange);
  },
  beforeUnmount() {
    emitter.off('map:3d-state-changed', this.handle3DStateChange);
  },
  methods: {
    zoomIn()            { window.map.zoomIn(); },
    zoomOut()           { window.map.zoomOut(); },
    orientationButton() { window.map.flyTo({ pitch: 0, bearing: 0 }); },
    boundsButton()      { window.map.fitBounds(this.fitBounds, { padding: this.fitBoundsPadding }); },
    locationButton() {
      const icon = document.getElementById('location_icon');
      icon.classList.add('spin');
      window.geoLocate.permissionAndTrigger();
      if (window.geoLocate._lastKnownPosition) icon.classList.remove('spin');
    },
    async toggle3D() {
      // Check if user is PRO+ before enabling 3D mode
      const isPro = await RevenueCatWrapper.isProOrProPlus();
      if (!isPro) {
        window.location.href = '/purchases';
        return;
      }

      const nextState = !ThreeDimensionalMapManager.is3DModeEnabled();
      ThreeDimensionalMapManager.set3DMode(nextState);
      this.is3DEnabled = ThreeDimensionalMapManager.is3DModeEnabled();
    },
    handle3DStateChange(enabled) {
      this.is3DEnabled = enabled;
    }
  },
};
</script>
